"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsGuardRequest = void 0;
require("@veeam/core");
class PermissionsGuardRequest {
    constructor(subject, resourceName, action) {
        this.subject = subject;
        this.resourceName = resourceName;
        this.action = action;
    }
    toJS() {
        return {
            subject: {
                permissions: this.subject.permissions,
            },
            resource: { name: this.resourceName },
            action: this.action,
        };
    }
}
exports.PermissionsGuardRequest = PermissionsGuardRequest;
//# sourceMappingURL=PermissionsGuardRequest.js.map